/* eslint-disable no-return-assign */
const properties = ['CompanyAsOfDate', 'CompanyCount', 'InceptionDate',
  'PortfolioTurnover', 'PortfolioTurnoverYear', 'StrategyAsOfDate',
  'StrategyAssets'];

const getters = {
  CompanyAsOfDate: localState => localState.CompanyAsOfDate,
  CompanyCount: localState => localState.CompanyCount,
  InceptionDate: localState => localState.InceptionDate,
  PortfolioTurnover: localState => localState.PortfolioTurnover,
  PortfolioTurnoverYear: localState => localState.PortfolioTurnoverYear,
  StrategyAsOfDate: localState => localState.StrategyAsOfDate,
  StrategyAssets: localState => localState.StrategyAssets
};

const mutations = {
  SET_FACTS(localState, payload) {
    for (const prop in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, prop)) {
        payload[prop] === -32768 ?
          localState[prop] = '--' :
          localState[prop] = payload[prop];
      }
    }
  }
};

const state = {};
properties.forEach(property => state[property] = '');

export default {
  getters,
  mutations,
  state
};
